import React, { useState, useEffect, useRef } from "react";
import {
  TextField,
  Typography,
  Container,
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  MenuItem,
  Menu,
  Card,
  CardContent,
  Grid,
  Checkbox,
  InputAdornment,
  Collapse,
  List,
  ListItem,
  ListItemText,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
  ListItemIcon,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import BuildCircleOutlinedIcon from "@mui/icons-material/BuildCircleOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Search } from "@mui/icons-material";
import CreateArrow from "../../../images/CreateArrow.svg";
import TokenConsumption from "../../../images/TokenConsumption.svg";
import DownloadIcon from "../../../images/DownloadIcon.svg";
import ProjectIcon from "../../../images/ProjectIcon.svg";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import * as XLSX from "xlsx";
import {
  deleteProject,
  getAllProjectsByAdmin,
  getServiceRequest,
} from "../../../services/webServices.js";
import CloseIcon from "@mui/icons-material/Close";
import { createProject } from "../../../services/webServices.js";
import SessionExpired from "../../popup-components/SessionExpiredPopup.js";
const ProjectsList = () => {
  // const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  //   const [teams, setTeams] = useState([]);
  const [expandedTeam, setExpandedTeam] = useState(null);
  const [totalProjects, setTotalProjects] = useState(0);
  const [totalTokensUsed, setTotalTokensUsed] = useState(0);
  // const [totalTimeSpent, setTotalTimeSpent] = useState(0);
  const [projects, setProjects] = useState([]);
  const [message, setMessage] = useState("");
  const [projectName, setProjectName] = useState("");
  const [open, setOpen] = useState(false);
  // const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const searchRef = useRef(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("All Status");
  const [messgeforprojectcreated, setMessageforporjectcreated] = useState("");
  const [sessionTime, setSessionTime] = useState(false);
  const [totalTasks, setTotalTasks] = useState(0);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  console.log(
    "projects",
    Array.isArray(projects)
      ? projects.filter(
          (project) => project.project_data.Status?.toLowerCase() === "active"
        ).length
      : 0
  );
  const [activeCount, setActiveCount] = useState();
  const [inactiveCount, setInactiveCount] = useState();

  //   const [expandedProject, setExpandedProject] = useState(null);

  const fetchProjects = async () => {
    const dates = { fromDate, toDate };
    try {
      const response = await getServiceRequest(dates);

      const data = response.data.data;
      const totalProjects = response.data.total_projects;
      const totalTasks = response.data.total_services_used;
      const totalTokensUsed = response.data.total_tokens_used;

      //   Group users by project_name with additional calculations
      const groupedProjects = data.reduce((acc, user) => {
        if (!acc[user.project_name]) {
          acc[user.project_name] = {
            name: user.project_name,
            users: [],
            totalMembers: 0,
            activeMembers: 0,
            totalTaskDone: 0,
            totalTaskCompleted: "0/0",
            avgSessionTime: "0 hrs",
            avgTimeSpent: "0 hrs",
            tokenUsed: 0,
            status: "Active",
          };
        }

        // Add user to the project
        acc[user.project_name].users.push(user);

        // Update project metrics
        acc[user.project_name].totalMembers =
          acc[user.project_name].users.length;
        acc[user.project_name].activeMembers = acc[
          user.project_name
        ].users.filter((u) => u.status === "Active").length;
        acc[user.project_name].tokenUsed += user.token_used || 0;

        // Calculate averages
        const usersCount = acc[user.project_name].users.length;
        acc[user.project_name].avgTimeSpent = `${Math.round(
          acc[user.project_name].users.reduce(
            (sum, u) => sum + (u.time_spent || 0),
            0
          ) / usersCount
        )} hrs`;
        acc[user.project_name].avgSessionTime = `${Math.round(
          acc[user.project_name].users.reduce(
            (sum, u) => sum + (u.session_time || 0),
            0
          ) / usersCount
        )} hrs`;

        acc[user.project_name].totalTaskDone += user.tasks_done || 0;

        return acc;
      }, {});

      const totalTasksCalculated = Object.values(groupedProjects).reduce(
        (sum, project) => sum + project.totalTaskDone,
        0
      );
      setTotalTasks(totalTasksCalculated); // ✅ Ensure state updates
      setProjects(Object.values(groupedProjects));

      const finalProjects = Object.values(groupedProjects);
      setActiveCount(
        Array.isArray(data)
          ? data.filter(
              (project) =>
                project.project_data.Status?.toLowerCase() === "active"
            ).length
          : 0
      );
      setInactiveCount(
        Array.isArray(data)
          ? data.filter(
              (project) =>
                project.project_data.Status?.toLowerCase() === "inactive"
            ).length
          : 0
      );

      setTotalProjects(totalProjects);
      setTotalTasks(totalTasks);
      setTotalTokensUsed(totalTokensUsed);
      setProjects(data);
    } catch (error) {
      console.error("Failed to fetch projects:", error);
    }
  };

  useEffect(() => {
    fetchProjects(); // Trigger fetch on initial render with default dates
  }, [fromDate, toDate]); // No dependency on dates here since it will be filtered later on Apply

  // const handleApplyFilter = () => {
  //   // Trigger filtering based on the selected date range
  //   fetchProjects();
  // };

  const handleSave = async (e) => {
    e.preventDefault();
    setProjectName("");
    try {
      const response = await createProject({
        projectName,
      });
      setMessage(`Project created: ${response.data.projectName}`);
      setMessageforporjectcreated("Project created successfully!");
      // fetchProjects();
    } catch (error) {
      setMessageforporjectcreated(error.response.data.Error);
      console.log("this is it", error.response.data.Error);
    }
  };

  // Functionality to downnload report
  const downloadReport = async () => {
    if (!projects || !Array.isArray(projects) || projects.length === 0) {
      alert("No project data available to download!");
      return;
    }

    let tableData = [];

    projects.map((project) => {
      const projectInfo = project.project_data;
      const users = project.users_data || []; // Ensure users_data is always an array

      if (users.length > 0) {
        users.forEach((user) => {
          tableData.push({
            "Project Name": projectInfo?.["Team/Project Name"] || "N/A",
            "Total Members": projectInfo?.["Total Members"] || "N/A",
            "Active Members": projectInfo?.["Active Members"] || "N/A",
            "Total Tasks Done": projectInfo?.["Total Tasks Done/Team"] || "N/A",
            "Avg Session Time/Team":
              projectInfo?.["Avg Session Time/Team"] || "N/A",
            "Avg Time Spent/User":
              projectInfo?.["Avg Time Spent/User"] || "N/A",
            "Tokens Used/Team": projectInfo?.["Token Used/Team"] || "N/A",
            Status: projectInfo?.["Status"] || "N/A",
            "User Name": user?.display_name || "N/A",
            "User Role": user?.designation || "N/A",
            "User Status": user?.status
              ? user.status.charAt(0).toUpperCase() + user.status.slice(1)
              : "N/A",
            "User Tasks Done": user?.tasks_done || "0",
            "User Avg Session Time": user?.avg_service_time
              ? `${user.avg_service_time} hrs`
              : "N/A",
            "User Tokens Used": user?.tokens_used || "0",
          });
        });
      } else {
        tableData.push({
          "Project Name": projectInfo?.["Team/Project Name"] || "N/A",
          "Total Members": projectInfo?.["Total Members"] || "N/A",
          "Active Members": projectInfo?.["Active Members"] || "N/A",
          "Total Tasks Done": projectInfo?.["Total Tasks Done/Team"] || "N/A",
          "Avg Session Time/User":
            projectInfo?.["Avg Session Time/Team"] || "N/A",
          "Total Time Spent/User":
            projectInfo?.["Avg Time Spent/User"] || "N/A",
          "Tokens Used/Team": projectInfo?.["Token Used/Team"] || "N/A",
          Status: projectInfo?.["Status"] || "N/A",
          "User Name": "N/A",
          "User Role": "N/A",
          "User Status": "N/A",
          "User Tasks Done": "N/A",
          "User Avg Session Time": "N/A",
          "User Tokens Used": "N/A",
        });
      }
    });

    const worksheet = XLSX.utils.json_to_sheet(tableData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Projects Report");
    // Adjust column widths for all columns
    const columnWidth = 20; // Set a uniform width for all columns
    const columnCount = Object.keys(tableData[0] || {}).length; // Count columns dynamically

    worksheet["!cols"] = new Array(columnCount).fill({ wch: columnWidth }); // Apply width to all columns
    const fileName = `Projects Report.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };

  const handlecloseprojectfield = () => {
    setOpen(false);
    setMessageforporjectcreated("");
  };

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        await getAllProjectsByAdmin();
      } catch (error) {
        console.error("Error fetching projects:", error);
        if (error.response.data.message === "Your session has expired.") {
          setSessionTime(true);
        }
      }
    };

    fetchProjects();
  }, []);

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleClose = () => {
    setOpen(false);
    setMessageforporjectcreated("");
  };
  const handleOpenDialog = (user) => {
    setUserToDelete(user);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setUserToDelete(null);
  };

  const confirmDelete = async (id) => {
    console.log("id", id);
    if (id) {
      await handleDeleteProject(id);
      handleCloseDialog();
      handleCloseMenu();
    }
  };

  useEffect(() => {
    setFilteredProjects(projects);
  }, [projects]);

  // useEffect(() => {
  //   if (fromDate && toDate) {
  //     const filtered = projects.filter(project => {
  //       const projectDate = new Date(project.project_data.date); // Assuming `date` exists in project_data

  //     });

  //     setFilteredProjects(filtered); // Update the state with filtered projects
  //   } else {
  //     setFilteredProjects(projects); // If no dates are selected, show all projects
  //   }
  // }, [fromDate, toDate, projects]);

  const handleMenuOpen = (event, user) => {
    setAnchorEl(event.currentTarget);
    setSelectedUser(user);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const toggleTeam = (teamName = "") => {
    setExpandedTeam((prev) => (prev === teamName ? null : teamName));
  };

  const handleDeleteProject = async (projectId) => {
    try {
      await deleteProject(projectId);
      alert("Project deleted successfully!");
      fetchProjects();
    } catch (error) {
      console.error("Error deleting project:", error);
    }
    handleMenuClose();
  };

  const handleSearchChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    //setShowSuggestions(query.length > 0);
    filterProjects(query, selectedStatus);
  };

  const handleStatusChange = (event) => {
    const status = event.target.value;
    setSelectedStatus(status);
    filterProjects(searchQuery, status);
  };
  const handleCreateClick = () => {
    setOpen(true);
  };

  const filterProjects = (query, status) => {
    if (!query && status === "All Status") {
      setFilteredProjects(projects);
      return;
    }

    const filtered = (projects || []).filter((project) => {
      const projectName = project?.project_data?.["Team/Project Name"]
        ? project.project_data["Team/Project Name"]
            .toLowerCase()
            .replace(/\s+/g, " ")
        : ""; // Ensure it's a valid string

      const userMatch = project?.users_data?.some((user) =>
        user?.display_name?.toLowerCase().includes(query)
      );

      const projectStatus = project?.project_data?.["Status"];
      const statusMatch =
        status === "All Status" ||
        (typeof projectStatus === "string" &&
          projectStatus.toLowerCase() === status.toLowerCase());

      return (projectName.includes(query) || userMatch) && statusMatch;
    });

    setFilteredProjects(filtered);
  };

  // Generate Suggestions for Dropdown
  const suggestions = projects.flatMap((project) => {
    const projectName = project.project_data?.["Team/Project Name"] || "";
    const normalizedProjectName = projectName ? projectName.toLowerCase() : "";
    const matchedUsers = (project.users_data || [])
      .filter((user) => user.username.toLowerCase().includes(searchQuery))
      .map((user) => user.username);

    return normalizedProjectName.includes(searchQuery)
      ? [projectName, ...matchedUsers]
      : matchedUsers;
  });

  // Handle Suggestion Click
  const handleSuggestionClick = (suggestion) => {
    setSearchQuery(suggestion);
    setShowSuggestions(false);
    filterProjects(suggestion.toLowerCase());
  };

  // Close Suggestions when Clicking Outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        bgcolor: "#F5F5F2",
        height: "calc(100vh - 150px)", // adjust as needed
        overflowY: "auto",
        maxHeight: "100vh",
        // "&::-webkit-scrollbar": {
        //   width: "6px", // Reduce width for a sleeker scrollbar
        // },
        // "&::-webkit-scrollbar-track": {
        //   backgroundColor: "#e0e0e0", // Lighter track for a softer look
        // },
        // "&::-webkit-scrollbar-thumb": {
        //   backgroundColor: "#b0b0b0", // Light gray for a subtle look
        //   borderRadius: "10px", // More rounded for a smooth appearance
        // },
        // "&::-webkit-scrollbar-thumb:hover": {
        //   backgroundColor: "#999", // Slightly darker on hover
        // },
      }}
    >
      <Container
        component="main"
        maxWidth={false}
        sx={{ marginLeft: "10px", marginRight: "10px" }}
      >
        <Box sx={{ my: 1, overflow: "hidden" }}>
          <Box
            sx={{
              my: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              overflow: "hidden",
            }}
          >
            <Typography variant="h6" component="h1" gutterBottom>
              Projects/Teams
            </Typography>
            <Box sx={{ display: "flex", gap: 2 }}>
              {/* Create Button  */}
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#0094FB",
                  color: "white",
                  textTransform: "none",
                }}
                endIcon={
                  <img
                    src={CreateArrow}
                    alt="Dropdown"
                    style={{ width: 16, height: 16, marginLeft: "5px" }}
                  />
                }
                onClick={handleCreateClick}
              >
                Create
              </Button>

              {/* Download Report Button */}
              <Button
                variant="outlined"
                sx={{
                  backgroundColor: "white",
                  color: "#0094FB",
                  border: "1px solid #0094FB",
                  textTransform: "none",
                }}
                endIcon={
                  <img
                    src={DownloadIcon}
                    alt="Download"
                    style={{ width: 16, height: 16, marginLeft: "5px" }}
                  />
                }
                onClick={downloadReport}
              >
                <b>Download Report</b>
              </Button>
            </Box>
          </Box>

          {/*  Create Project Dialog POPUP */}
          <Dialog open={open} onClose={handleClose}
          slotProps={{
            paper: {
              sx: {
                width: 400,      // Customize width
                minHeight: 100,  // Customize height
              },
            },
          }}
          >
            <DialogTitle>
              Create Project
              <IconButton
                onClick={handlecloseprojectfield} // Close dialog when clicked
                sx={{
                  position: "absolute", // Position the close button absolutely
                  top: "8px", // Adjust distance from top
                  right: "8px", // Adjust distance from right
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <TextField
                margin="dense"
                label="Project Name"
                name="project name"
                fullWidth
                value={projectName}
                onChange={(e) => setProjectName(e.target.value)}
              />

              {messgeforprojectcreated && (
                <Box sx={{ mt: 2, color: "blue", fontSize: "18px" }}>
                  {messgeforprojectcreated}
                </Box>
              )}
            </DialogContent>
            <DialogActions>
              <Button
              sx={{
                textTransform: "none",
                fontSize: 17,
                backgroundColor: "#0094FB",
              }}
                onClick={handleSave}
                color="primary"
                disabled={!projectName.trim()}
                variant="contained"
              >
                Create
              </Button>
            </DialogActions>
          </Dialog>

          {/* === 4 Equal-Spaced Cards === */}
          <Grid
            container
            spacing={3}
            sx={{ marginBottom: "20px", marginTop: "-10px" }}
          >
            {" "}
            {/* Move cards up */}
            {/* card for total projects */}
            <Grid item xs={12} sm={4}>
              <Card
                sx={{
                  padding: "15px",
                  borderRadius: "12px",
                  boxShadow: "none",
                  border: "1px solid #ddd",
                  height: "110px",
                  position: "relative", // Ensures the footer stays at the bottom
                }}
              >
                <CardContent sx={{ paddingBottom: "50px" }}>
                  {" "}
                  {/* Space for footer */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginTop: "-30px",
                    }}
                  >
                    <img
                      src={ProjectIcon}
                      alt="User Icon"
                      style={{
                        width: "50px",
                        height: "80px",
                        marginLeft: "-20px",
                      }}
                    />
                    <Box>
                      <Typography variant="p" color="textSecondary">
                        Total Projects
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <Typography variant="h6">{totalProjects}</Typography>
                      </Box>
                    </Box>
                  </Box>
                </CardContent>

                {/* Footer with full-width grey background */}
                <Box
                  sx={{
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    width: "100%",
                    backgroundColor: "#f0f0f0",
                    padding: "10px",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      px: 2,
                    }}
                  >
                    <Typography variant="body1" sx={{ color: "grey" }}>
                      Active:{" "}
                      <span
                        style={{
                          color: "black",
                          padding: "4px 8px",
                          borderRadius: "4px",
                        }}
                      >
                        {activeCount}
                      </span>
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ color: "grey", marginRight: "20px" }}
                    >
                      Inactive:{" "}
                      <span
                        style={{
                          color: "#F44336",
                          padding: "4px 8px",
                          borderRadius: "4px",
                        }}
                      >
                        {inactiveCount}
                      </span>
                    </Typography>
                  </Box>
                </Box>
              </Card>
            </Grid>
            {/* card for  token consumption */}
            <Grid item xs={12} sm={4}>
              <Card
                sx={{
                  padding: "15px",
                  borderRadius: "12px",
                  boxShadow: "none",
                  border: "1px solid #ddd",
                  height: "110px",
                  position: "relative", // Ensure footer sticks to the bottom
                }}
              >
                <CardContent sx={{ paddingBottom: "50px" }}>
                  {" "}
                  {/* Reserve space for footer */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginTop: "-30px",
                    }}
                  >
                    <img
                      src={TokenConsumption}
                      alt="Token Icon"
                      style={{
                        width: "50px",
                        height: "80px",
                        marginLeft: "-20px",
                      }}
                    />
                    <Box>
                      <Typography variant="body2" color="textSecondary">
                        Token Consumption
                      </Typography>
                      <Typography variant="h6">{totalTokensUsed}</Typography>
                    </Box>
                  </Box>
                </CardContent>

                {/* Footer with full-width grey background */}
                <Box
                  sx={{
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    width: "100%",
                    backgroundColor: "#f0f0f0",
                    padding: "10px",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      px: 2,
                    }}
                  >
                    {/* <Typography variant="body1" sx={{ color: "grey" }}>
                      Total:
                    </Typography> */}
                    {/* <Typography
                      variant="body1"
                      sx={{ color: "grey", marginRight: "20px" }}
                    >
                      Remaining:{" "}
                      
                    </Typography> */}
                  </Box>
                </Box>
              </Card>
            </Grid>
            {/* card for time spent */}
            <Grid item xs={12} sm={4}>
              <Card
                sx={{
                  padding: "15px",
                  borderRadius: "12px",
                  boxShadow: "none",
                  border: "1px solid #ddd",
                  height: "110px",
                  position: "relative", // Ensure footer sticks to the bottom
                }}
              >
                <CardContent sx={{ paddingBottom: "50px" }}>
                  {" "}
                  {/* Space for footer */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginTop: "-15px",
                    }}
                  >
                    <BuildCircleOutlinedIcon
                      sx={{
                        fontSize: 40, // Adjust icon size
                        color: "#4A90E2", // Matches the theme of your provided icon
                        marginLeft: "-10px",
                      }}
                    />
                    <Box>
                      <Typography variant="p" color="textSecondary">
                        Total Services Used
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <Typography variant="h6">{totalTasks || 0}</Typography>
                      </Box>
                    </Box>
                  </Box>
                </CardContent>

                {/* Footer with full-width grey background */}
                <Box
                  sx={{
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    width: "100%",
                    backgroundColor: "#f0f0f0",
                    padding: "10px",
                    borderBottomLeftRadius: "12px",
                    borderBottomRightRadius: "12px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      px: 2,
                    }}
                  >
                    {/* <Typography variant="body1" sx={{ color: "grey" }}>
                      Average:{" "}
                      <span style={{ color: "black" }}>
                        {users.length > 0
                          ? (
                            users.reduce(
                              (total, user) =>
                                total + (user.avg_service_time || 0),
                              0
                            ) / users.length
                          ).toFixed(2)
                          : 1.2}{" "}
                        hr
                      </span>
                    </Typography> */}
                    {/* <Typography
                      variant="body1"
                      sx={{ color: "grey", marginRight: "20px" }} // Moves Time Saved slightly left
                    >
                      Time Saved:{" "}
                      {/* <span style={{ color: "green" }}>
                        {users.length > 0
                          ? (
                              53 -
                              users.reduce(
                                (total, user) => total + (user.time_spent || 0),
                                0
                              ) /
                                users.length
                            ).toFixed(1)
                          : 30} hr/user
                      </span> 
                    </Typography> */}
                  </Box>
                </Box>
              </Card>
            </Grid>
          </Grid>

          {/* === End of Cards === */}

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
              marginBottom: 2,
            }}
          >
            {/* Search Bar */}
            <Box
              sx={{
                flex: 1,
                maxWidth: "280px",
                position: "relative",
                width: "100%",
                background: "#FFFFFF",
              }}
            >
              <TextField
                variant="outlined"
                placeholder="Search Project/User"
                value={searchQuery}
                onChange={handleSearchChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                  sx: { height: "30px" },
                }}
                sx={{ width: "100%", borderRadius: "20px" }}
              />
              {showSuggestions && (
                <Paper sx={{ position: "absolute", width: "100%", zIndex: 10 }}>
                  <List dense>
                    {suggestions.map((suggestion, index) => (
                      <ListItem
                        key={index}
                        button
                        onClick={() => handleSuggestionClick(suggestion)}
                      >
                        <ListItemText primary={suggestion} />
                      </ListItem>
                    ))}
                  </List>
                </Paper>
              )}
            </Box>

            {/* Dropdown Filters */}
            <Box
              sx={{
                display: "flex",
                gap: 2,
                flexWrap: "wrap",
                justifyContent: { xs: "center", sm: "flex-start" },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 1,
                }}
              >
                <TextField
                  label="From"
                  variant="outlined"
                  margin="normal"
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  sx={{
                    // width: "80%",
                    // "& .MuiOutlinedInput-root": { padding: "4px 14px" },
                  }} // Adjust padding to reduce height
                />

                <TextField
                  label="To"
                  variant="outlined"
                  margin="normal"
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  // sx={{ width: "80%" }}
                />
                {/* <Button
                  sx={{
                    textTransform: "none",
                    width: "20%",
                    height: "40px",
                    marginTop: "23px",
                    backgroundColor: "#49a3ff",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#49a3ff" },
                  }}
                    onClick={handleApplyFilter}
                >
                  Apply
                </Button> */}
              </Box>

              {/* <TextField
                select
                value="All Users"
                size="small"
                SelectProps={{
                  IconComponent: () => (
                    <img
                      src={DropDownIcon}
                      alt="Dropdown"
                      style={{ width: 16, height: 16, marginRight: "8px" }}
                    />
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "30px",
                    fontSize: "14px",
                    background: "#FFFFFF",
                  },
                }}
              >
                <MenuItem value="All Users" sx={{ fontSize: "14px" }}>
                  All Users
                </MenuItem>
                <MenuItem value="Active Users" sx={{ fontSize: "14px" }}>
                  Active Users
                </MenuItem>
                <MenuItem value="Inactive Users" sx={{ fontSize: "14px" }}>
                  Inactive Users
                </MenuItem>
              </TextField> */}

              {/* <TextField
                select
                value={selectedStatus}
                onChange={handleStatusChange}
                size="small"
                SelectProps={{
                  IconComponent: () => (
                    <img
                      src={DropDownIcon}
                      alt="Dropdown"
                      style={{ width: 16, height: 16, marginRight: "8px" }}
                    />
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "30px",
                    fontSize: "14px",
                    background: "#FFFFFF",
                  },
                }}
              >
                <MenuItem value="All Status" sx={{ fontSize: "14px" }}>
                  All Status
                </MenuItem>
                <MenuItem value="Active" sx={{ fontSize: "14px" }}>
                  Active
                </MenuItem>
                <MenuItem value="Inactive" sx={{ fontSize: "14px" }}>
                  Inactive
                </MenuItem>
              </TextField> */}

              {/* <TextField
                select
                value="All Role"
                size="small"
                SelectProps={{
                  IconComponent: () => (
                    <img
                      src={DropDownIcon}
                      alt="Dropdown"
                      style={{ width: 16, height: 16, marginRight: "8px" }}
                    />
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "30px",
                    fontSize: "14px",
                    background: "#FFFFFF",
                  },
                }}
              >
                <MenuItem value="All Role" sx={{ fontSize: "14px" }}>
                  All Role
                </MenuItem>
                <MenuItem value="Admin" sx={{ fontSize: "14px" }}>
                  Admin
                </MenuItem>
                <MenuItem value="User" sx={{ fontSize: "14px" }}>
                  User
                </MenuItem>
              </TextField> */}

              {/* <TextField
                select
                value="All Service"
                size="small"
                SelectProps={{
                  IconComponent: () => (
                    <img
                      src={DropDownIcon}
                      alt="Dropdown"
                      style={{ width: 16, height: 16, marginRight: "8px" }}
                    />
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "30px",
                    fontSize: "14px",
                    background: "#FFFFFF",
                  },
                }}
              >
                <MenuItem value="All Service" sx={{ fontSize: "14px" }}>
                  All Service
                </MenuItem>
                <MenuItem value="Service 1 " sx={{ fontSize: "14px" }}>
                  Service 1
                </MenuItem>
                <MenuItem value="Service 2" sx={{ fontSize: "14px" }}>
                  Service 2
                </MenuItem>
              </TextField> */}
            </Box>
          </Box>

          {/* User Table */}
          <TableContainer component={Paper} sx={{ overflow: "auto", mt: 3 }}>
            <Table sx={{ minWidth: 650, borderCollapse: "collapse" }}>
              <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
                <TableRow sx={{ border: "1px solid #ddd" }}>
                  <TableCell
                    padding="checkbox"
                    sx={{
                      fontSize: "14px",
                      color: "grey",
                      borderRight: "1px solid #ddd",
                      whiteSpace: "nowrap",
                      minWidth: "15px",
                    }}
                  >
                    <center>
                      {" "}
                      <Checkbox size="small" />
                    </center>
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: "14px",
                      color: "grey",
                      borderRight: "1px solid #ddd",
                      //whiteSpace: "nowrap",
                    }}
                  >
                    Team/Project Name
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: "14px",
                      color: "grey",
                      borderRight: "1px solid #ddd",
                      // whiteSpace: "nowrap",
                    }}
                  >
                    Total Members
                  </TableCell>

                  <TableCell
                    sx={{
                      fontSize: "14px",
                      borderRight: "1px solid #ddd",
                      color: "grey",
                      //whiteSpace: "nowrap",
                    }}
                  >
                    Tasks Done
                  </TableCell>
                  {/* <TableCell
                    sx={{
                      fontSize: "14px",
                      borderRight: "1px solid #ddd",
                      color: "grey",
                      //  whiteSpace: "nowrap",
                    }}
                  >
                    Avg Session Time/Team
                  </TableCell> */}
                  {/* <TableCell
                    sx={{
                      fontSize: "14px",
                      borderRight: "1px solid #ddd",
                      color: "grey",
                      // whiteSpace: "nowrap",
                    }}
                  >
                    Avg Time Spent/User
                  </TableCell> */}
                  <TableCell
                    sx={{
                      fontSize: "14px",
                      borderRight: "1px solid #ddd",
                      color: "grey",
                      // whiteSpace: "nowrap",
                    }}
                  >
                    Tokens Used/Team
                  </TableCell>
                  {/* <TableCell
                    sx={{
                      fontSize: "14px",
                      borderRight: "1px solid #ddd",
                      color: "grey",
                      // whiteSpace: "nowrap",
                    }}
                  >
                    DU
                  </TableCell> */}
                  <TableCell
                    sx={{
                      fontSize: "14px",
                      borderRight: "1px solid #ddd",
                      color: "grey",
                      //whiteSpace: "nowrap",
                    }}
                  >
                    Status
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: "14px",
                      borderRight: "1px solid #ddd",
                      color: "grey",
                      //  whiteSpace: "nowrap",
                    }}
                  ></TableCell>
                </TableRow>
              </TableHead>
              <TableBody
                sx={{
                  borderRight: "1px solid #ddd", // Ensure right border is visible
                }}
              >
                {(filteredProjects || []).map((project, index) => (
                  <React.Fragment
                    key={project.project_data["Team/Project Name"]}
                  >
                    <TableRow
                      sx={{
                        lineHeight: "1",
                        backgroundColor:
                          expandedTeam ===
                          project.project_data["Team/Project Name"]
                            ? "#BED8F3"
                            : "inherit",
                        padding: "4px 0", // Reduced padding
                      }}
                    >
                      <TableCell
                        padding="checkbox"
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px 8px", // Adjusted cell padding
                        }}
                      >
                        <center>
                          {" "}
                          <Checkbox size="small" />
                        </center>
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px 8px",
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <IconButton
                            size="small"
                            onClick={() =>
                              toggleTeam(
                                project?.project_data?.["Team/Project Name"] ||
                                  ""
                              )
                            }
                          >
                            {expandedTeam ===
                            (project?.project_data?.["Team/Project Name"] ||
                              "") ? (
                              <ExpandLessIcon />
                            ) : (
                              <ExpandMoreIcon />
                            )}
                          </IconButton>
                          {project?.project_data?.["Team/Project Name"] || ""}
                        </Box>
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px 8px",
                        }}
                      >
                        {project.project_data["Total Members"]}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px 8px",
                        }}
                      >
                        {project.project_data["Total Tasks Done/Team"]}
                      </TableCell>
                      {/* <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px 8px",
                        }}
                      >
                        {(
                          project.project_data["Avg Session Time/Team"] / 3600
                        ).toFixed(2)}{" "}
                        hr
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px 8px",
                        }}
                      >
                        {(
                          project.project_data["Avg Time Spent/User"] / 3600
                        ).toFixed(2)}
                        {""} hrs
                      </TableCell> */}
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px 8px",
                        }}
                      >
                        {project.project_data["Token Used/Team"]}
                      </TableCell>
                      {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: '4px 8px' }}>{project.project_data["Token Used"]}</TableCell> */}
                      {/* <TableCell>
                                                <span
                                                    style={{
                                                        color:
                                                            project.project_data.status === "Active"
                                                                ? "#4CAF50"
                                                                : "#F44336",
                                                        backgroundColor:
                                                            project.project_data.status === "Active"
                                                                ? "#E8F5E9"
                                                                : "#FFEBEE",
                                                        padding: "4px 8px",
                                                        borderRadius: "4px",
                                                    }}
                                                >
                                                    {project.project_data["Status"]}
                                                </span>
                                            </TableCell> */}
                      {/* <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px 8px",
                        }}
                      >
                        {project.project_data["Status"]}
                      </TableCell> */}
                      {/* <TableCell
  sx={{
    borderRight: "1px solid #ddd",
    padding: "4px 8px",
    color: project.project_data["Status"] === "Active" ? "#4CAF50" : "#F44336",
    backgroundColor: project.project_data["Status"] === "Active" ? "#E8F5E9" : "#FFEBEE",
    borderRadius: "4px",
  }}
>
  {project.project_data["Status"]}
</TableCell> */}
                      {/* <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px 8px",
                        }}
                      >
                        {project.project_data["DU"]}
                      </TableCell> */}
                      <TableCell
                        sx={{
                          borderRight: "1px solid #ddd",
                          padding: "4px 8px",
                        }}
                      >
                        <span
                          style={{
                            color:
                              project.project_data["Status"] === "Active"
                                ? "#4CAF50"
                                : "#F44336",
                            backgroundColor:
                              project.project_data["Status"] === "Active"
                                ? "#E8F5E9"
                                : "#FFEBEE",
                            padding: "4px 8px",
                            borderRadius: "4px",
                            border:
                              project.project_data["Status"] === "Active"
                                ? " #4CAF50"
                                : " #F44336",
                          }}
                        >
                          {project.project_data["Status"]}
                        </span>
                      </TableCell>

                      <TableCell sx={{ padding: "4px 8px" }}>
                        <IconButton onClick={(e) => handleMenuOpen(e, project)}>
                          <MoreVertIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{ paddingBottom: 0, paddingTop: 0 }}
                        colSpan={9}
                      >
                        <Collapse
                          in={
                            expandedTeam ===
                            project.project_data["Team/Project Name"]
                          } // Ensure this comparison is correct
                          timeout="auto"
                          unmountOnExit
                        >
                          <Table
                            size="small"
                            sx={{
                              borderCollapse: "collapse",
                              borderSpacing: "0 10px",
                            }}
                          >
                            <TableHead>
                              <TableRow sx={{ borderBottom: "none" }}>
                                <TableCell
                                  sx={{
                                    padding: "12px 16px",

                                    // Prevents collapsing (Adjust as needed)
                                    // Makes it expand based on content
                                    // Minimum width to expand cells

                                    border: "none", // No border
                                  }}
                                />
                                <TableCell
                                  sx={{
                                    fontSize: "14px",
                                    color: "grey",
                                    whiteSpace: "nowrap",
                                    textAlign: "center",
                                    padding: "8px 57px",
                                    border: "1px solid #ddd",
                                    width: "120px",
                                    maxWidth: "45px",
                                  }}
                                >
                                  User ID
                                </TableCell>
                                <TableCell
                                  sx={{
                                    fontSize: "14px",
                                    color: "grey",
                                    whiteSpace: "nowrap",
                                    textAlign: "center",
                                    padding: "8px 16px",
                                    border: "1px solid #ddd",
                                    // minWidth:"50px"  // Add a visible border
                                  }}
                                >
                                  User Name
                                </TableCell>
                                <TableCell
                                  sx={{
                                    fontSize: "14px",
                                    color: "grey",
                                    whiteSpace: "nowrap",
                                    textAlign: "center",
                                    padding: "8px 16px",
                                    border: "1px solid #ddd", // Add a visible border
                                  }}
                                >
                                  Role / Designation
                                </TableCell>
                                <TableCell
                                  sx={{
                                    fontSize: "14px",
                                    color: "grey",
                                    whiteSpace: "nowrap",
                                    textAlign: "centre",
                                    border: "1px solid #ddd", // Add a visible border
                                    padding: "8px 16px",
                                  }}
                                >
                                  Status
                                </TableCell>
                                <TableCell
                                  sx={{
                                    fontSize: "14px",
                                    color: "grey",
                                    whiteSpace: "nowrap",
                                    textAlign: "center",
                                    padding: "8px 16px",
                                    border: "1px solid #ddd", // Add a visible border
                                  }}
                                >
                                  Tasks Done
                                </TableCell>
                                {/* <TableCell
                                  sx={{
                                    fontSize: "14px",
                                    color: "grey",
                                    whiteSpace: "nowrap",
                                    textAlign: "center",
                                    padding: "8px 16px",
                                    border: "1px solid #ddd", // Add a visible border
                                  }}
                                >
                                  Avg Session Time
                                </TableCell> */}
                                <TableCell
                                  sx={{
                                    fontSize: "14px",
                                    color: "grey",
                                    whiteSpace: "nowrap",
                                    textAlign: "center",
                                    padding: "8px 16px",
                                    border: "1px solid #ddd",
                                    width: "100px", // Adjust based on other cells

                                    // Adjust this value as needed

                                    // Add a visible border
                                  }}
                                >
                                  Tokens Used
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {project.users_data.map((user) => (
                                <TableRow
                                  key={user.user_id}
                                  sx={{
                                    borderBottom: "none",
                                    backgroundColor: "#fff", // White background for better visibility
                                    "&:hover": { backgroundColor: "#F8F9FC" }, // Light hover effect
                                  }}
                                >
                                  <TableCell
                                    sx={{
                                      padding: "8px",
                                      border: "none", // No border
                                    }}
                                  />

                                  <TableCell
                                    sx={{
                                      textAlign: "center",
                                      padding: "8px 66px",
                                      border: "1px solid #ddd", // Add a visible border
                                    }}
                                  >
                                    {user.user_id}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      textAlign: "center",
                                      padding: "8px 16px",
                                      border: "1px solid #ddd", // Add a visible border
                                    }}
                                  >
                                    {user.display_name}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      textAlign: "center",
                                      padding: "8px 16px",
                                      border: "1px solid #ddd", // Add a visible border
                                    }}
                                  >
                                    {user.designation}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      textAlign: "center",
                                      padding: "8px 16px",
                                      border: "1px solid #ddd", // Add a visible border
                                    }}
                                  >
                                    <span
                                      style={{
                                        color:
                                          user.status === "active"
                                            ? "#4CAF50"
                                            : "#F44336",
                                        // backgroundColor:
                                        //   user.status === "active"
                                        //     ? "#E8F5E9"
                                        //     : "#FFEBEE",
                                        padding: "4px 8px",
                                        //borderRadius: "4px",
                                      }}
                                    >
                                      {user.status.charAt(0).toUpperCase() +
                                        user.status.slice(1).toLowerCase()}

                                      {/* {user.status} */}
                                    </span>
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      textAlign: "center",
                                      padding: "8px 16px",
                                      border: "1px solid #ddd", // Add a visible border
                                    }}
                                  >
                                    {user.tasks_done || "0"}
                                  </TableCell>
                                  {/* <TableCell
                                    sx={{
                                      textAlign: "center",
                                      padding: "8px 16px",
                                      border: "1px solid #ddd", // Add a visible border
                                    }}
                                  >
                                    {user.avg_service_time
                                      ? `${(
                                          user.avg_service_time / 3600
                                        ).toFixed(2)} hr`
                                      : "0 hrs"}
                                  </TableCell> */}
                                  <TableCell
                                    sx={{
                                      textAlign: "center",
                                      padding: "8px 16px",
                                      border: "1px solid #ddd", // Add a visible border
                                    }}
                                  >
                                    {user.tokens_used || 0}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              PaperProps={{
                elevation: 3, // Shadow effect
                sx: {
                  borderRadius: "8px",
                  minWidth: "180px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                },
              }}
            >
              <MenuItem
                onClick={() =>
                  alert(`View Details: ${selectedUser?.display_name}`)
                }
              >
                <ListItemIcon>
                  <VisibilityOutlinedIcon
                    fontSize="small"
                    sx={{ color: "#007BFF" }}
                  />
                </ListItemIcon>
                <Typography variant="body2">View Details</Typography>
              </MenuItem>

              <MenuItem
                onClick={() =>
                  alert(`Assign Project to ${selectedUser?.display_name}`)
                }
              >
                <ListItemIcon>
                  <AssignmentOutlinedIcon
                    fontSize="small"
                    sx={{ color: "#007BFF" }}
                  />
                </ListItemIcon>
                <Typography variant="body2">Assign Project</Typography>
              </MenuItem>

              <MenuItem
                sx={{ color: "red" }}
                // onClick={(e) => {
                //   e.stopPropagation(); // Prevent event bubbling
                //   if (selectedUser?.id) {
                //     if (
                //       window.confirm(
                //         `Are you sure you want to delete ${selectedUser.display_name}?`
                //       )
                //     ) {
                //       handleDeleteUser(selectedUser.id);
                //     }
                //   }
                // }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenDialog(selectedUser);
                }}
              >
                <ListItemIcon>
                  <DeleteOutlineIcon fontSize="small" sx={{ color: "red" }} />
                </ListItemIcon>
                <Typography
                  variant="body2"
                  sx={{ color: "red" }}
                  // onClick={() => handleDeleteUser(user.id)}
                >
                  Delete Users
                </Typography>
              </MenuItem>
              <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                PaperProps={{
                  sx: {
                    maxWidth: "300px",
                    minWidth: "300px",
                    borderRadius: "8px",
                    p: 1,
                  },
                }}
                BackdropProps={{
                  sx: {
                    backgroundColor: "rgba(0, 0, 0, 0.5)", // lighter backdrop
                  },
                }}
              >
                <DialogTitle
                  sx={{
                    pb: 1,
                    fontSize: "1.1rem",
                  }}
                >
                  Delete Users
                </DialogTitle>
                <DialogContent sx={{ pb: 2 }}>
                  <Typography>
                    Are you sure you want to delete {userToDelete?.display_name}
                    ?
                  </Typography>
                </DialogContent>
                <DialogActions sx={{ px: 2, pb: 2 }}>
                  <Button
                    onClick={handleCloseDialog}
                    variant="outlined"
                    size="small"
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={(e) => {
                      confirmDelete(userToDelete?.project_data?.project_id);
                    }}
                    color="error"
                    variant="contained"
                    size="small"
                  >
                    Delete
                  </Button>
                </DialogActions>
              </Dialog>
            </Menu>
          </TableContainer>
        </Box>
      </Container>
      {sessionTime && <SessionExpired />}
    </Box>
  );
};

export default ProjectsList;
